import {ValidationResult} from "../../util/validation/validation-result"
import {validateRequiredField} from "../../util/validation/validations"

export interface SignUpFormViewModel {
  readonly email: string
  readonly password: string
}

export type SignUpFormViewModelTextInputFields = {
  [K in keyof SignUpFormViewModel]: SignUpFormViewModel[K] extends string ? K : never
}[keyof SignUpFormViewModel]

export type SignUpFormViewModelValidationResult = {
  [K in SignUpFormViewModelTextInputFields]: ValidationResult
}

export function createEmptySignUpFormViewModel(): SignUpFormViewModel {
  return {
    email: "",
    password: ""
  }
}

export function validateSignUpFormViewModel(viewModel: SignUpFormViewModel): SignUpFormViewModelValidationResult {
  return {
    email: validateRequiredField(viewModel.email),
    password: validateRequiredField(viewModel.password)
  }
}
